import { BudgetCategoryGroup } from "@project/domain/models/budget/financial-entity-budget.model";

export class CreateBudgetCategoryGroup {
    constructor(
        public name: BudgetCategoryGroup["name"],
        public category: BudgetCategoryGroup["category"],
    ) {}
}
